import { useTranslation } from 'react-i18next';
import { cx } from '@platform/core/lib/cx';
import { useAppDispatch, useAppSelector } from '@platform/state/hooks';
import { selectUi } from '@platform/state/selectors';
import { rightPanelChanged } from '@platform/state/slices/uiSlice';
import type { IAiButtonProps } from './IAiButtonProps';

/**
 * Кнопка ШІ-асистента (UIUX top-bar, patterns/ai-assistant, прототип v4): пігулка 34px «✦ ШІ» на напівпрозорому тлі; відкрита панель —
 * біла з синім текстом (aria-pressed). Відкриває праву панель асистента, що лишається відкритою між сторінками.
 */
export function AiButton({ className }: IAiButtonProps) {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const on = useAppSelector((s) => selectUi(s).rightPanel === 'ai');
  return (
    <button type="button" className={cx('tb-ai', className)} title={t('shell.aiAssistant')} aria-label={t('shell.aiAssistant')} aria-pressed={on}
      onClick={() => dispatch(rightPanelChanged(on ? null : 'ai'))}>
      {/* Іскра прототипу v4 (велика й мала чотирикутні зірки) — власний знак ШІ, якого немає в Lucide */}
      <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M12 3l1.9 4.6L18.5 9.5l-4.6 1.9L12 16l-1.9-4.6L5.5 9.5l4.6-1.9z" />
        <path d="M19 15l.8 1.9L21.7 18l-1.9.8L19 20.7l-.8-1.9L16.3 18l1.9-1.1z" />
      </svg>
      <span>{t('shell.ai')}</span>
    </button>
  );
}
